import React, { useEffect, useState } from 'react'
import './profile.scss'
import { useLocation } from "react-router-dom";
import { update } from 'lodash';
import API_CONSTANTS from './../../api-constants'



const Newsletter = ({ newsletter, orgNo, setUpdatedNewsgroup }) => {

    const [updatedNewsletter, setUpdatedNewsletter] = useState()
    const [isChecked, setIsChecked] = useState(newsletter.Active === 1 || updatedNewsletter?.Active === 1 ? true : false)
    const [checked_arr, setChecked_arr] = useState([])
    const [triggerEffect, setTriggerEffect] = useState(false)
    let key = sessionStorage.getItem('key')
    let email = sessionStorage.getItem('email')
   

   // console.log(newsletter, 'newsletter')

    function newsletterChanged(e) {
       // console.log(e)
        const id = e.target.id;
        const checked = e.target.checked;
        setIsChecked(checked)
        let sign_on = checked === true ? 1 : 0
        let obj = {
            id: id,
            customerEmail: email,
            isSubscribed:checked
        }
     //   console.log(obj, 'obj')
           
            //.then(result => console.log(result))
        fetch(`${API_CONSTANTS.fetchUrl}/systemnative/customer.asmx/UpdateNewsgroup?Key=${key}&OrgNo=${orgNo}&NewsgroupNo=${newsletter.No}&SignOn=${sign_on}`, {
            method: "GET",
            headers: {
                'ebilletToken': "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
                'Content-Type': 'application/x-www-form-urlencoded',
            },  
        
                    })
             .then((res) => res.json())
                .then(result => {
                   // console.log(result, 'result from update')
                    setUpdatedNewsletter(result)
                    setUpdatedNewsgroup(result)
                })
    }
  //  console.log(updatedNewsletter, 'updated newsletter')
    

   
    return (


        <form style={{ display:'flex' }} key={newsletter.No} onClick={() => setTriggerEffect(true)} onAnimationEnd={() => setTriggerEffect(false)}>

          
            <input style={{ width: '20px', height: '20px', marginRight: '10px',borderRadius:'3px' }} type="checkbox" id={newsletter.No} checked={isChecked}
                    onChange={newsletterChanged} />
            <label for={newsletter.No} >  {newsletter.Name}  </label>
                       
            {isChecked ? <span className={triggerEffect ? 'subscribed fade-in-out' : 'subscribed'}> Tilmeldt</span>
                :  <span className={triggerEffect ? 'unsubscribed fade-in-out' : 'unsubscribed'}> Frameldt</span>}
          </form>
                                   
        
    )
}

export default Newsletter